import _asyncToGenerator from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _CACHE_SEED_TOKENS;

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { Token } from '@uniswap/sdk-core';
import _ from 'lodash';
import { ChainId, log, WRAPPED_NATIVE_CURRENCY } from '../util';
import { CELO, CELO_ALFAJORES, CEUR_CELO, CUSD_CELO, CUSD_CELO_ALFAJORES, DAI_ARBITRUM, DAI_ARBITRUM_RINKEBY, DAI_CELO, DAI_CELO_ALFAJORES, DAI_MAINNET, DAI_MOONBEAM, DAI_OPTIMISM, DAI_OPTIMISTIC_KOVAN, DAI_POLYGON_MUMBAI, DAI_RINKEBY_1, DAI_RINKEBY_2, UNI_ARBITRUM_RINKEBY, USDC_ARBITRUM, USDC_ARBITRUM_RINKEBY, USDC_ETHEREUM_GNOSIS, USDC_MAINNET, USDC_MOONBEAM, USDC_OPTIMISM, USDC_OPTIMISTIC_KOVAN, USDC_POLYGON, USDT_ARBITRUM, USDT_ARBITRUM_RINKEBY, USDT_MAINNET, USDT_OPTIMISM, USDT_OPTIMISTIC_KOVAN, WBTC_ARBITRUM, WBTC_MAINNET, WBTC_MOONBEAM, WBTC_OPTIMISM, WBTC_OPTIMISTIC_KOVAN, WMATIC_POLYGON, WMATIC_POLYGON_MUMBAI } from './token-provider'; // These tokens will added to the Token cache on initialization.

export var CACHE_SEED_TOKENS = (_CACHE_SEED_TOKENS = {}, _defineProperty(_CACHE_SEED_TOKENS, ChainId.MAINNET, {
  WETH: WRAPPED_NATIVE_CURRENCY[ChainId.MAINNET],
  USDC: USDC_MAINNET,
  USDT: USDT_MAINNET,
  WBTC: WBTC_MAINNET,
  DAI: DAI_MAINNET,
  // This token stores its symbol as bytes32, therefore can not be fetched on-chain using
  // our token providers.
  // This workaround adds it to the cache, so we won't try to fetch it on-chain.
  RING: new Token(ChainId.MAINNET, '0x9469D013805bFfB7D3DEBe5E7839237e535ec483', 18, 'RING', 'RING')
}), _defineProperty(_CACHE_SEED_TOKENS, ChainId.RINKEBY, {
  WETH: WRAPPED_NATIVE_CURRENCY[ChainId.RINKEBY],
  DAI_1: DAI_RINKEBY_1,
  DAI_2: DAI_RINKEBY_2
}), _defineProperty(_CACHE_SEED_TOKENS, ChainId.OPTIMISM, {
  USDC: USDC_OPTIMISM,
  USDT: USDT_OPTIMISM,
  WBTC: WBTC_OPTIMISM,
  DAI: DAI_OPTIMISM
}), _defineProperty(_CACHE_SEED_TOKENS, ChainId.OPTIMISTIC_KOVAN, {
  USDC: USDC_OPTIMISTIC_KOVAN,
  USDT: USDT_OPTIMISTIC_KOVAN,
  WBTC: WBTC_OPTIMISTIC_KOVAN,
  DAI: DAI_OPTIMISTIC_KOVAN
}), _defineProperty(_CACHE_SEED_TOKENS, ChainId.ARBITRUM_ONE, {
  USDC: USDC_ARBITRUM,
  USDT: USDT_ARBITRUM,
  WBTC: WBTC_ARBITRUM,
  DAI: DAI_ARBITRUM
}), _defineProperty(_CACHE_SEED_TOKENS, ChainId.ARBITRUM_RINKEBY, {
  USDT: USDT_ARBITRUM_RINKEBY,
  UNI: UNI_ARBITRUM_RINKEBY,
  DAI: DAI_ARBITRUM_RINKEBY,
  USDC: USDC_ARBITRUM_RINKEBY
}), _defineProperty(_CACHE_SEED_TOKENS, ChainId.POLYGON, {
  WMATIC: WMATIC_POLYGON,
  USDC: USDC_POLYGON
}), _defineProperty(_CACHE_SEED_TOKENS, ChainId.POLYGON_MUMBAI, {
  WMATIC: WMATIC_POLYGON_MUMBAI,
  DAI: DAI_POLYGON_MUMBAI
}), _defineProperty(_CACHE_SEED_TOKENS, ChainId.CELO, {
  CELO: CELO,
  CUSD: CUSD_CELO,
  CEUR: CEUR_CELO,
  DAI: DAI_CELO
}), _defineProperty(_CACHE_SEED_TOKENS, ChainId.CELO_ALFAJORES, {
  CELO: CELO_ALFAJORES,
  CUSD: CUSD_CELO_ALFAJORES,
  CEUR: CUSD_CELO_ALFAJORES,
  DAI: DAI_CELO_ALFAJORES
}), _defineProperty(_CACHE_SEED_TOKENS, ChainId.GNOSIS, {
  WXDAI: WRAPPED_NATIVE_CURRENCY[ChainId.GNOSIS],
  USDC_ETHEREUM_GNOSIS: USDC_ETHEREUM_GNOSIS
}), _defineProperty(_CACHE_SEED_TOKENS, ChainId.MOONBEAM, {
  USDC: USDC_MOONBEAM,
  DAI: DAI_MOONBEAM,
  WBTC: WBTC_MOONBEAM,
  WGLMR: WRAPPED_NATIVE_CURRENCY[ChainId.MOONBEAM]
}), _CACHE_SEED_TOKENS);
/**
 * Provider for getting token metadata that falls back to a different provider
 * in the event of failure.
 *
 * @export
 * @class CachingTokenProviderWithFallback
 */

export var CachingTokenProviderWithFallback = /*#__PURE__*/function () {
  function CachingTokenProviderWithFallback(chainId, // Token metadata (e.g. symbol and decimals) don't change so can be cached indefinitely.
  // Constructing a new token object is slow as sdk-core does checksumming.
  tokenCache, primaryTokenProvider, fallbackTokenProvider) {
    _classCallCheck(this, CachingTokenProviderWithFallback);

    this.chainId = chainId;
    this.tokenCache = tokenCache;
    this.primaryTokenProvider = primaryTokenProvider;
    this.fallbackTokenProvider = fallbackTokenProvider;

    this.CACHE_KEY = function (chainId, address) {
      return "token-".concat(chainId, "-").concat(address);
    };
  }

  _createClass(CachingTokenProviderWithFallback, [{
    key: "getTokens",
    value: function () {
      var _getTokens = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_addresses) {
        var seedTokens, _i, _Object$values, token, addressToToken, symbolToToken, addresses, addressesToFindInPrimary, addressesToFindInSecondary, _iterator, _step, _address2, primaryTokenAccessor, _iterator2, _step2, address, _token, secondaryTokenAccessor, _iterator3, _step3, _address, _token2;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                seedTokens = CACHE_SEED_TOKENS[this.chainId];

                if (!seedTokens) {
                  _context.next = 10;
                  break;
                }

                _i = 0, _Object$values = Object.values(seedTokens);

              case 3:
                if (!(_i < _Object$values.length)) {
                  _context.next = 10;
                  break;
                }

                token = _Object$values[_i];
                _context.next = 7;
                return this.tokenCache.set(this.CACHE_KEY(this.chainId, token.address.toLowerCase()), token);

              case 7:
                _i++;
                _context.next = 3;
                break;

              case 10:
                addressToToken = {};
                symbolToToken = {};
                addresses = _(_addresses).map(function (address) {
                  return address.toLowerCase();
                }).uniq().value();
                addressesToFindInPrimary = [];
                addressesToFindInSecondary = [];
                _iterator = _createForOfIteratorHelper(addresses);
                _context.prev = 16;

                _iterator.s();

              case 18:
                if ((_step = _iterator.n()).done) {
                  _context.next = 34;
                  break;
                }

                _address2 = _step.value;
                _context.next = 22;
                return this.tokenCache.has(this.CACHE_KEY(this.chainId, _address2));

              case 22:
                if (!_context.sent) {
                  _context.next = 31;
                  break;
                }

                _context.next = 25;
                return this.tokenCache.get(this.CACHE_KEY(this.chainId, _address2));

              case 25:
                addressToToken[_address2.toLowerCase()] = _context.sent;
                _context.next = 28;
                return this.tokenCache.get(this.CACHE_KEY(this.chainId, _address2));

              case 28:
                symbolToToken[addressToToken[_address2].symbol] = _context.sent;
                _context.next = 32;
                break;

              case 31:
                addressesToFindInPrimary.push(_address2);

              case 32:
                _context.next = 18;
                break;

              case 34:
                _context.next = 39;
                break;

              case 36:
                _context.prev = 36;
                _context.t0 = _context["catch"](16);

                _iterator.e(_context.t0);

              case 39:
                _context.prev = 39;

                _iterator.f();

                return _context.finish(39);

              case 42:
                log.info({
                  addressesToFindInPrimary: addressesToFindInPrimary
                }, "Found ".concat(addresses.length - addressesToFindInPrimary.length, " out of ").concat(addresses.length, " tokens in local cache. ").concat(addressesToFindInPrimary.length > 0 ? "Checking primary token provider for ".concat(addressesToFindInPrimary.length, " tokens") : "", "\n      "));

                if (!(addressesToFindInPrimary.length > 0)) {
                  _context.next = 72;
                  break;
                }

                _context.next = 46;
                return this.primaryTokenProvider.getTokens(addressesToFindInPrimary);

              case 46:
                primaryTokenAccessor = _context.sent;
                _iterator2 = _createForOfIteratorHelper(addressesToFindInPrimary);
                _context.prev = 48;

                _iterator2.s();

              case 50:
                if ((_step2 = _iterator2.n()).done) {
                  _context.next = 63;
                  break;
                }

                address = _step2.value;
                _token = primaryTokenAccessor.getTokenByAddress(address);

                if (!_token) {
                  _context.next = 60;
                  break;
                }

                addressToToken[address.toLowerCase()] = _token;
                symbolToToken[addressToToken[address].symbol] = _token;
                _context.next = 58;
                return this.tokenCache.set(this.CACHE_KEY(this.chainId, address.toLowerCase()), addressToToken[address]);

              case 58:
                _context.next = 61;
                break;

              case 60:
                addressesToFindInSecondary.push(address);

              case 61:
                _context.next = 50;
                break;

              case 63:
                _context.next = 68;
                break;

              case 65:
                _context.prev = 65;
                _context.t1 = _context["catch"](48);

                _iterator2.e(_context.t1);

              case 68:
                _context.prev = 68;

                _iterator2.f();

                return _context.finish(68);

              case 71:
                log.info({
                  addressesToFindInSecondary: addressesToFindInSecondary
                }, "Found ".concat(addressesToFindInPrimary.length - addressesToFindInSecondary.length, " tokens in primary. ").concat(this.fallbackTokenProvider ? "Checking secondary token provider for ".concat(addressesToFindInSecondary.length, " tokens") : "No fallback token provider specified. About to return."));

              case 72:
                if (!(this.fallbackTokenProvider && addressesToFindInSecondary.length > 0)) {
                  _context.next = 97;
                  break;
                }

                _context.next = 75;
                return this.fallbackTokenProvider.getTokens(addressesToFindInSecondary);

              case 75:
                secondaryTokenAccessor = _context.sent;
                _iterator3 = _createForOfIteratorHelper(addressesToFindInSecondary);
                _context.prev = 77;

                _iterator3.s();

              case 79:
                if ((_step3 = _iterator3.n()).done) {
                  _context.next = 89;
                  break;
                }

                _address = _step3.value;
                _token2 = secondaryTokenAccessor.getTokenByAddress(_address);

                if (!_token2) {
                  _context.next = 87;
                  break;
                }

                addressToToken[_address.toLowerCase()] = _token2;
                symbolToToken[addressToToken[_address].symbol] = _token2;
                _context.next = 87;
                return this.tokenCache.set(this.CACHE_KEY(this.chainId, _address.toLowerCase()), addressToToken[_address]);

              case 87:
                _context.next = 79;
                break;

              case 89:
                _context.next = 94;
                break;

              case 91:
                _context.prev = 91;
                _context.t2 = _context["catch"](77);

                _iterator3.e(_context.t2);

              case 94:
                _context.prev = 94;

                _iterator3.f();

                return _context.finish(94);

              case 97:
                return _context.abrupt("return", {
                  getTokenByAddress: function getTokenByAddress(address) {
                    return addressToToken[address.toLowerCase()];
                  },
                  getTokenBySymbol: function getTokenBySymbol(symbol) {
                    return symbolToToken[symbol.toLowerCase()];
                  },
                  getAllTokens: function getAllTokens() {
                    return Object.values(addressToToken);
                  }
                });

              case 98:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[16, 36, 39, 42], [48, 65, 68, 71], [77, 91, 94, 97]]);
      }));

      function getTokens(_x) {
        return _getTokens.apply(this, arguments);
      }

      return getTokens;
    }()
  }]);

  return CachingTokenProviderWithFallback;
}();